import { useApi, PROFILE_STATUS } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

export function useProfileStatus() {
  const api = useApi();
  
  const { data, isLoading, error } = useQuery({
    queryKey: ["expert", "hasExpert"],
    queryFn: () => api.expert.hasExpertProfile(),
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep unused data in cache for 10 minutes
  });

  const profileStatus = computed(() => data.value?.profile_status);
  const isDraft = computed(() => profileStatus.value === PROFILE_STATUS.DRAFT);
  const isPro = computed(() => data.value?.is_pro);

  return {
    profileStatus,
    isDraft,
    isPro,
    isLoading,
    error,
  };
}

export default useProfileStatus;

